import request from '@meitu/saas-editor-ui/es/request';
import {
    CheckLoginResponse,
    FetchUserInfoParams,
    FetchUserInfoResponse,
    ISavaUserMaterialParams,
    IUserObsTokenParams,
    LogoutResponse,
    TGetMattSign,
    TSavaUserMaterialResponse,
    TUserObsTokenResponse,
} from './index.d';

/**
 * 用户信息详情
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/82889
 */
export const fetchUserInfo = async function (params: FetchUserInfoParams) {
    return await request<FetchUserInfoResponse>('/center/user_info.json', {
        method: 'GET',
        params,
    });
};

/**
 * 旧官网用户退出
 *
 */
export const userLogout = async function (params: FetchUserInfoParams) {
    return await request<LogoutResponse>('/user/logout', {
        method: 'GET',
        params,
        hideErrorToast: true,
    });
};

/**
 * 用户信息
 */
export const checkLogin = async function () {
    return await request<CheckLoginResponse>('/user/checkLogin', {
        method: 'GET',
        hideErrorToast: true,
    });
};
/**
 * 素材保存
 */
export const savaUserMaterial = async function (data: ISavaUserMaterialParams) {
    return await request<TSavaUserMaterialResponse>('/my_picture/save.json', {
        method: 'POST',
        data,
        hideErrorToast: true,
    });
};

/**
 * 获取签名
 */

export const getMaatSign = async function name() {
    const res = await request<TGetMattSign>('/user/maat/maat/getsign', {
        method: 'GET',
        // 每个项目type不一样 具体问培金
        params: {
            type: 'posters',
        },
    });
    const data = res?.data?.data || {};
    if (data.sig_version) {
        delete data.sig_version;
        delete data.access_token;
        delete data.host;
    }
    const { app, type, count, suffix, sig, sig_time: sigTime } = data;
    return {
        app,
        type,
        count,
        suffix,
        sig,
        sigTime,
    };
};

/**
 * 获取上传图片token信息
 */
export const getObsToken = async function (params: IUserObsTokenParams) {
    const rsp = await request<TUserObsTokenResponse>('/upload/policy', {
        method: 'GET',
        params,
    });
    const [data] = rsp.data;
    return data.mtyun;
};
